import template from "./quote-new-section.html";

const QuoteNewSectionComponent = {
  bindings: {
    index: "<",
    onAddSection: "&",
    onCancelAddSection: "&",
  },
  template: template,
  controller: class QuoteNewSectionController {
    /* @ngInject */
    constructor($scope, ModalsManager) {
      this.$scope = $scope;
      this.ModalsManager = ModalsManager;
    }

    async openSectionGallery() {
      const selectedSection = await this.ModalsManager.openSectionGalleryModal();
      if (!selectedSection) return;

      this.onAddSection({
        type: selectedSection.sectionType,
        quoteSection: selectedSection,
      });
    }
  },
};

export default QuoteNewSectionComponent;
